<ng-container *ngIf="breakpointServiceMin.breakpoint$ | async as breakpoint">
    <header class="slider-header">
        <h2 class="display-5 headline">{{ headline }}</h2>

        <div class="kk-slider-buttons slider-buttons" *ngIf="slider.hasPaging">
            <button
                class="kk-slider-button"
                [ngClass]="{ 'button-faded': !slider.pagingLeftPossible }"
                (click)="slider.previous()"
            >
                <span class="arrow kk-float-horizontally-left">
                    <app-svg-icon aria-hidden="true" iconName="chevron_left"></app-svg-icon>
                </span>
                <span class="kk-visuallyhidden"> {{ 'general.action.next' | translateSafe }}</span>
            </button>
            <button
                class="kk-slider-button"
                [ngClass]="{ 'button-faded': !slider.pagingRightPossible }"
                (click)="slider.next()"
            >
                <span class="arrow kk-float-horizontally-right">
                    <app-svg-icon aria-hidden="true" iconName="chevron_right"></app-svg-icon>
                </span>
                <span class="kk-visuallyhidden">{{ 'general.action.previous' | translateSafe }}</span>
            </button>
        </div>
    </header>

    <!--
        We need to add the space of the overlay padding to make the slider out of the boundaries,
        that is the main reason i'm using the flag isMobile.
        on the width the 1.625rem (8px) is calculated based on the 2.125rem (34px) of padding less 0.625rem (10px)
     -->
    <div class="options-grid">
        <app-slider
            class="options-slider"
            [scrollByItems]="1"
            [pageIndex]="selectedOptionIndex"
            [style]="{
                paddingTop: '20px',
                paddingBottom: '20px',
                paddingRight: slider.hasPaging ? (breakpoint?.isMobile ? '2.125rem' : '7.5rem') : '0',
                scrollPaddingRight: slider.hasPaging ? (breakpoint?.isMobile ? '2.125rem' : '7.5rem') : '0',
                width: 'calc(100% + ' + (breakpoint?.isMobile ? '1.625rem' : '7.5rem') + ')'
            }"
            #slider
        >
            <ng-content></ng-content>
        </app-slider>
    </div>
</ng-container>
